import React from 'react'
const ParticipantList = ctx => {
  return <ul className="panel">
    { ctx.participants.map((participant, i) => {
      return <li className="panel-block" key={`participant-${participant.displayName}-${i}`}>
        { participant.displayName }
      </li>
    })}
  </ul>
}

export default ParticipantList
